import BasicContent from '../Page/BasicContent';

export default BasicContent;
